import { action, computed, makeObservable, observable } from 'mobx';

import {
  DictionarySettingsValueEntity,
  DictionarySettingsValueEntityApi,
  normalizeDictionarySettingValueToServerEntity,
} from 'entities/DictionarySettings';
import { ILocalStore, IServerEntity } from 'stores/interfaces';

/**
 * Модель поля в справочнике
 */
export class DictionarySettingsValueModel
  implements
    IServerEntity<DictionarySettingsValueEntityApi>,
    DictionarySettingsValueEntity,
    ILocalStore
{
  constructor(entity: DictionarySettingsValueEntity) {
    this.id = entity.id as number | string;

    this.value = entity.value;
    this.fieldId = entity.fieldId;
    this.priority = entity.priority;

    makeObservable<DictionarySettingsValueModel>(this, {
      value: observable,

      label: computed,
      toServerFormat: computed,

      setLabel: action.bound,
    });
  }

  readonly id: number | string;

  value: string;
  readonly fieldId: number;
  readonly priority: number | undefined;

  /**
   * Назвзание поля
   */
  get label() {
    return this.value;
  }

  /**
   * Нормализация в json
   */
  get toServerFormat(): DictionarySettingsValueEntityApi {
    return normalizeDictionarySettingValueToServerEntity(this);
  }

  setLabel(l: string): void {
    this.value = l;
  }

  destroy() {}
}
